import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { Injectable } from '@angular/core';
import { StockDocDto, SupplierDeliveryNoteDto } from '@digiwall/goliath-documents/proxy';
import { firstValueFrom } from 'rxjs';

export interface IBaseStockDocDetail {
  get document(): StockDocDto | SupplierDeliveryNoteDto;
  get saveFromExtends(): () => void;
  get afterSaveFromExtends(): () => void;
  get navigateAfterSaveFromExtends(): () => void;
}
@Injectable()
export class BaseStockDocDetailHelperService {
  private _doc: IBaseStockDocDetail;
  public set Doc(value: IBaseStockDocDetail) {
    this._doc = value;
  }

  private _validateOnLeave: Promise<void>;
  private _resolveValidateOnLeave: () => void;

  constructor(private confirmationService: ConfirmationService) {}

  protected navigateAfterSave(): void {
    if (this._resolveValidateOnLeave) {
      // Document was validated via the canDeactivate, skip navigation
      return;
    }
    this._doc.navigateAfterSaveFromExtends();
  }

  protected afterSave(): void {
    this._doc.afterSaveFromExtends();
    let resolveValidateOnLeave = this._resolveValidateOnLeave;
    if (resolveValidateOnLeave) {
      resolveValidateOnLeave();
      resolveValidateOnLeave = null;
      this._validateOnLeave = null;
    }
  }

  public canDeactivate = async () => {
    const document = this._doc.document;
    if (!document?.id || document?.isStockValidated || (document?.lines?.length ?? 0) == 0) {
      // Skip if document is not yet saved, or already validated, or has no lines
      return true;
    }

    // Document is in update mode and it is not validated
    const status = await firstValueFrom(
      this.confirmationService.warn('Doc::Doc:IsNotValidatedMessage', 'Doc::Doc:IsNotValidated', {
        dismissible: false,
        yesText: '::ToValidate',
        cancelText: '::Quit',
      }),
    );
    if (status == Confirmation.Status.confirm) {
      // Validate before leaving
      this._validateOnLeave = new Promise<void>(resolve => {
        this._resolveValidateOnLeave = resolve;
      });
      this._doc.saveFromExtends();
      await this._validateOnLeave;
    }
    return true;
  };
}
